(function () {
  var root = document.querySelector('[data-pmg-app]');
  if (!root) return;

  var workerUrl = (root.getAttribute('data-pmg-worker-url') || '').replace(/\/$/, '');
  if (!workerUrl) return;

  var loginView = root.querySelector('[data-pmg-login]');
  var contentView = root.querySelector('[data-pmg-content]');
  var loginForm = root.querySelector('[data-pmg-login-form]');
  var loginError = root.querySelector('[data-pmg-login-error]');
  var createForm = root.querySelector('[data-pmg-create-form]');
  var createError = root.querySelector('[data-pmg-create-error]');
  var createSubmitButton = createForm.querySelector('button[type="submit"]');
  var createCountLabel = root.querySelector('[data-pmg-create-count]');
  var refreshButton = root.querySelector('[data-pmg-refresh]');
  var rowsBody = root.querySelector('[data-pmg-rows]');
  var summaryEl = root.querySelector('[data-pmg-summary]');
  var productSearchInput = root.querySelector('[data-pmg-product-search]');
  var productResultsEl = root.querySelector('[data-pmg-product-results]');
  var selectedProductsEl = root.querySelector('[data-pmg-selected-products]');
  var skuLabel = root.querySelector('[data-pmg-sku-label]');
  var pdpImageInput = root.querySelector('[data-pmg-pdp-image-input]');
  var pdpImagePreview = root.querySelector('[data-pmg-pdp-image-preview]');
  var pdpImageRemoveButton = root.querySelector('[data-pmg-pdp-image-remove]');
  var pdpImageStatus = root.querySelector('[data-pmg-pdp-image-status]');
  var viewButtons = root.querySelectorAll('[data-pmg-view-button]');
  var viewPanels = root.querySelectorAll('[data-pmg-view-panel]');
  var openCreateButtons = root.querySelectorAll('[data-pmg-open-create]');
  var createSteps = root.querySelectorAll('[data-pmg-create-step]');
  var stepIndicators = root.querySelectorAll('[data-pmg-step-indicator]');
  var prevStepButton = root.querySelector('[data-pmg-step-prev]');
  var nextStepButton = root.querySelector('[data-pmg-step-next]');
  var builderKicker = root.querySelector('[data-pmg-builder-kicker]');
  var builderTitle = root.querySelector('[data-pmg-builder-title]');
  var builderCopy = root.querySelector('[data-pmg-builder-copy]');
  var finishTitle = root.querySelector('[data-pmg-finish-title]');
  var finishCopy = root.querySelector('[data-pmg-finish-copy]');
  var saveLabel = root.querySelector('[data-pmg-save-label]');

  var selectedProducts = []; // [{handle, title, image}, ...]
  var latestSearchResults = [];
  var currentPromotions = [];
  var editingPromotion = null;
  var pdpImageFileId = null;
  var currentCreateStep = 0;

  function api(path, options) {
    options = options || {};
    return fetch(workerUrl + path, Object.assign({ credentials: 'include' }, options))
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          if (!response.ok) {
            var message = body && body.error ? body.error : 'Request failed (' + response.status + ')';
            if (body && Array.isArray(body.details) && body.details.length) {
              message += ': ' + body.details.join('; ');
            }
            throw new Error(message);
          }
          return body;
        });
      });
  }

  function showError(target, message) {
    if (!target) return;
    target.textContent = message;
    target.hidden = false;
  }

  function clearError(target) {
    if (!target) return;
    target.hidden = true;
    target.textContent = '';
  }

  function scrollWorkspaceIntoView() {
    if (!contentView || contentView.hidden) return;
    window.requestAnimationFrame(function () {
      var navHeight = root.querySelector('.pmg__top-nav') ? root.querySelector('.pmg__top-nav').offsetHeight : 68;
      var top = contentView.getBoundingClientRect().top + window.pageYOffset - navHeight - 18;
      window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
    });
  }

  function setAppView(view, refresh) {
    Array.prototype.forEach.call(viewPanels, function (panel) {
      panel.hidden = panel.getAttribute('data-pmg-view-panel') !== view;
    });
    Array.prototype.forEach.call(viewButtons, function (button) {
      var isActive = button.getAttribute('data-pmg-view-button') === view;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    root.setAttribute('data-pmg-current-view', view);
    if (view === 'create') setCreateStep(currentCreateStep);
    if (view === 'promotions' && refresh) loadPromotions();
    scrollWorkspaceIntoView();
  }

  function setCreateStep(index, keepScroll) {
    var maxIndex = Math.max(createSteps.length - 1, 0);
    currentCreateStep = Math.max(0, Math.min(index, maxIndex));

    Array.prototype.forEach.call(createSteps, function (step, stepIndex) {
      step.hidden = stepIndex !== currentCreateStep;
    });
    Array.prototype.forEach.call(stepIndicators, function (indicator, stepIndex) {
      indicator.classList.toggle('is-active', stepIndex === currentCreateStep);
      indicator.classList.toggle('is-complete', stepIndex < currentCreateStep);
      indicator.setAttribute('aria-current', stepIndex === currentCreateStep ? 'step' : 'false');
    });

    if (prevStepButton) prevStepButton.disabled = currentCreateStep === 0;
    if (nextStepButton) nextStepButton.hidden = currentCreateStep === maxIndex;
    if (createSubmitButton) createSubmitButton.hidden = currentCreateStep !== maxIndex;
    clearError(createError);
    if (!keepScroll) scrollWorkspaceIntoView();
  }

  function formField(name) {
    return createForm.elements[name];
  }

  function validateCreateStep(index) {
    clearError(createError);

    if (index === 0) {
      var campaign = formField('campaign');
      if (campaign && !campaign.checkValidity()) {
        campaign.reportValidity();
        return false;
      }
      if (!selectedProducts.length) {
        showError(createError, 'Select at least one product before continuing.');
        productSearchInput.focus();
        return false;
      }
    }

    if (index === 1) {
      var discount = formField('discount_percent');
      var price = formField('price');
      var hasDiscount = discount && String(discount.value || '').trim() !== '';
      var hasPrice = price && String(price.value || '').trim() !== '';
      var priceFields = ['discount_percent', 'price', 'base_price', 'after_discount_percent', 'after_price'];
      for (var priceFieldIndex = 0; priceFieldIndex < priceFields.length; priceFieldIndex += 1) {
        var priceField = formField(priceFields[priceFieldIndex]);
        if (priceField && String(priceField.value || '').trim() !== '' && !priceField.checkValidity()) {
          priceField.reportValidity();
          return false;
        }
      }
      if (!hasDiscount && !hasPrice) {
        showError(createError, 'Add a discount percent or an exact sale price.');
        if (discount) discount.focus();
        return false;
      }
    }

    if (index === 2) {
      var startAt = formField('start_at');
      var endAt = formField('end_at');
      if (startAt && !startAt.checkValidity()) {
        startAt.reportValidity();
        return false;
      }
      if (endAt && !endAt.checkValidity()) {
        endAt.reportValidity();
        return false;
      }
      if (startAt && endAt && startAt.value && endAt.value && new Date(endAt.value).getTime() <= new Date(startAt.value).getTime()) {
        showError(createError, 'End time must be after the start time.');
        endAt.focus();
        return false;
      }
    }

    return true;
  }

  function validateCreateFlow() {
    for (var stepIndex = 0; stepIndex < createSteps.length - 1; stepIndex += 1) {
      if (!validateCreateStep(stepIndex)) {
        setCreateStep(stepIndex);
        return false;
      }
    }
    return true;
  }

  function setText(target, value) {
    if (target) target.textContent = value;
  }

  function setBuilderMode(mode) {
    var isEditing = mode === 'edit';
    setText(builderKicker, isEditing ? 'Edit promotion' : 'Promotion builder');
    setText(builderTitle, isEditing ? 'Edit promotion' : 'Create promotion');
    setText(
      builderCopy,
      isEditing
        ? 'Update this promotion while it is still a draft. Approved, active, and ended promotions stay locked.'
        : 'Build the promotion in short steps, then save it as a draft for approval before it can go live.'
    );
    setText(finishTitle, isEditing ? 'Review and update draft' : 'Review and save as draft');
    setText(
      finishCopy,
      isEditing
        ? 'Review the details, then update this draft. It still needs approval before it can go live.'
        : 'Add PDP banner details if needed. This saves the promotion as a draft; it still needs approval before it can go live.'
    );
    setText(saveLabel, isEditing ? 'Update draft' : 'Save as draft');
  }

  function toDateTimeLocal(value) {
    if (!value) return '';
    var date = new Date(value);
    if (isNaN(date.getTime())) return '';
    var offsetDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return offsetDate.toISOString().slice(0, 16);
  }

  function fieldValue(name, value) {
    var field = formField(name);
    if (field) field.value = value || '';
  }

  function resetCreateForm() {
    editingPromotion = null;
    createForm.reset();
    selectedProducts = [];
    pdpImageFileId = null;
    renderSelectedProducts();
    resetPdpImage();
    setBuilderMode('create');
    setCreateStep(0);
  }

  function selectedProductFromPromotion(promotion) {
    var handle = promotion.product_handle || '';
    var target = handle || promotion.variant_id || 'Promotion target';
    return {
      handle: handle,
      variant_id: promotion.variant_id || '',
      title: target,
      image: null,
    };
  }

  function editPromotion(promotion) {
    if (!promotion || promotion.status !== 'draft') return;
    editingPromotion = promotion;
    createForm.reset();
    resetPdpImage();
    fieldValue('campaign', promotion.campaign);
    fieldValue('variant_sku', promotion.variant_sku);
    fieldValue('discount_percent', promotion.discount_percent);
    fieldValue('price', promotion.price);
    fieldValue('base_price', promotion.base_price);
    fieldValue('start_at', toDateTimeLocal(promotion.start_at));
    fieldValue('end_at', toDateTimeLocal(promotion.end_at));
    fieldValue('after_discount_percent', promotion.after_discount_percent);
    fieldValue('after_price', promotion.after_price);
    fieldValue('pdp_discount_code', promotion.pdp_discount_code);
    fieldValue('pdp_link', promotion.pdp_link);
    fieldValue('pdp_bar_badge', promotion.pdp_bar_badge);
    fieldValue('pdp_bar_text', promotion.pdp_bar_text);
    fieldValue('notes', promotion.notes);
    selectedProducts = [selectedProductFromPromotion(promotion)];
    pdpImageFileId = promotion.pdp_image || null;
    if (pdpImageFileId && promotion.pdp_image_preview_url) {
      showPdpImagePreview(promotion.pdp_image_preview_url, 'Image selected');
    } else if (pdpImageFileId && pdpImageStatus) {
      pdpImageStatus.textContent = 'Image selected, preview unavailable';
    }
    renderSelectedProducts();
    setBuilderMode('edit');
    setCreateStep(0);
    setAppView('create', false);
  }

  function showLoggedIn(skipRefresh) {
    loginView.hidden = true;
    contentView.hidden = false;
    setAppView('promotions', !skipRefresh);
  }

  function showLoggedOut() {
    loginView.hidden = false;
    contentView.hidden = true;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatDiscount(promotion) {
    if (promotion.discount_percent) return promotion.discount_percent + '%';
    if (promotion.price) return String(promotion.price);
    return '-';
  }

  function formatTarget(promotion) {
    var target = promotion.product_handle || promotion.variant_id || '-';
    if (promotion.variant_sku) target += ' (' + promotion.variant_sku + ')';
    return target;
  }

  function formatDate(value) {
    if (!value) return '-';
    var date = new Date(value);
    if (isNaN(date.getTime())) return value;
    return date.toLocaleString();
  }

  var DELETABLE_STATUSES = { draft: true, ended: true, rolled_back: true, error: true };

  function actionsForPromotion(promotion) {
    var actions = [];
    if (promotion.status === 'draft') {
      actions.push('<button type="button" class="pmg__action-btn pmg__action-btn--edit" data-pmg-edit-promotion="' + escapeHtml(promotion.id) + '">Edit</button>');
      actions.push('<button type="button" class="pmg__action-btn" data-pmg-approve="' + escapeHtml(promotion.id) + '">Approve</button>');
      actions.push('<button type="button" class="pmg__action-btn pmg__action-btn--cancel" data-pmg-cancel="' + escapeHtml(promotion.id) + '">Cancel</button>');
    } else if (promotion.status === 'approved') {
      var notYetStarted = promotion.start_at && new Date(promotion.start_at).getTime() > Date.now();
      if (notYetStarted) {
        actions.push('<button type="button" class="pmg__action-btn pmg__action-btn--cancel" data-pmg-cancel="' + escapeHtml(promotion.id) + '">Cancel</button>');
      } else {
        actions.push('<span>Live shortly (or use the rollback CLI to stop it)</span>');
      }
    } else if (promotion.status === 'active') {
      actions.push('<span>Use the manual rollback CLI to end this early</span>');
    }
    if (DELETABLE_STATUSES[promotion.status]) {
      actions.push('<button type="button" class="pmg__action-btn pmg__action-btn--cancel" data-pmg-delete="' + escapeHtml(promotion.id) + '">Delete</button>');
    }
    return actions.join(' ');
  }

  var STATUS_LABELS = { draft: 'Draft', approved: 'Approved', active: 'Active', ended: 'Ended', rolled_back: 'Cancelled', error: 'Error' };
  var STATUS_ORDER = { draft: 0, approved: 1, active: 2, error: 3, ended: 4, rolled_back: 5 };

  function renderSummary(promotions) {
    var counts = {};
    promotions.forEach(function (promotion) {
      var status = promotion.status || 'draft';
      counts[status] = (counts[status] || 0) + 1;
    });
    var parts = Object.keys(STATUS_LABELS)
      .filter(function (status) { return counts[status]; })
      .map(function (status) {
        return '<span class="pmg__summary-item pmg__status--' + status + '">' + counts[status] + ' ' + STATUS_LABELS[status].toLowerCase() + '</span>';
      });
    summaryEl.innerHTML = parts.length ? parts.join('') : '<span class="pmg__summary-item">No promotions yet</span>';
  }

  function renderPromotions(promotions) {
    currentPromotions = promotions || [];
    renderSummary(promotions);

    if (!promotions.length) {
      rowsBody.innerHTML = '<tr><td colspan="7" class="pmg__empty">No promotions yet.</td></tr>';
      return;
    }

    var sorted = promotions.slice().sort(function (a, b) {
      var orderA = STATUS_ORDER[a.status] != null ? STATUS_ORDER[a.status] : 99;
      var orderB = STATUS_ORDER[b.status] != null ? STATUS_ORDER[b.status] : 99;
      if (orderA !== orderB) return orderA - orderB;
      return (a.start_at || '').localeCompare(b.start_at || '');
    });

    rowsBody.innerHTML = sorted.map(function (promotion) {
      var canEdit = promotion.status === 'draft';
      return '<tr' + (canEdit ? ' class="pmg__row--editable" data-pmg-edit-promotion="' + escapeHtml(promotion.id) + '" tabindex="0" aria-label="Edit ' + escapeHtml(promotion.campaign || 'promotion') + '"' : '') + '>' +
        '<td><span class="pmg__status pmg__status--' + escapeHtml(promotion.status || 'draft') + '">' + escapeHtml(promotion.status || 'draft') + '</span></td>' +
        '<td>' + escapeHtml(promotion.campaign) + '</td>' +
        '<td>' + escapeHtml(formatTarget(promotion)) + '</td>' +
        '<td>' + escapeHtml(formatDiscount(promotion)) + '</td>' +
        '<td>' + escapeHtml(formatDate(promotion.start_at)) + '</td>' +
        '<td>' + escapeHtml(formatDate(promotion.end_at)) + '</td>' +
        '<td>' + actionsForPromotion(promotion) + '</td>' +
        '</tr>';
    }).join('');
  }

  function loadPromotions() {
    rowsBody.innerHTML = '<tr><td colspan="7" class="pmg__empty">Loading...</td></tr>';
    api('/promotions')
      .then(function (data) {
        renderPromotions(data.promotions || []);
      })
      .catch(function (error) {
        if (/not authenticated|session expired/i.test(error.message)) {
          showLoggedOut();
          return;
        }
        rowsBody.innerHTML = '<tr><td colspan="7" class="pmg__empty">' + escapeHtml(error.message) + '</td></tr>';
      });
  }

  // ---------------------------------------------------------------------
  // Product picker (search + multi-select)
  // ---------------------------------------------------------------------

  function renderSelectedProducts() {
    if (!selectedProducts.length) {
      selectedProductsEl.innerHTML = '<p class="pmg__picker-empty">No products selected yet.</p>';
    } else {
      selectedProductsEl.innerHTML = selectedProducts.map(function (product, index) {
        return '<span class="pmg__chip">' +
          (product.image ? '<img src="' + escapeHtml(product.image) + '" alt="">' : '<span class="pmg__chip-noimg"></span>') +
          '<span>' + escapeHtml(product.title) + '</span>' +
          '<button type="button" data-pmg-remove-product="' + index + '" aria-label="Remove ' + escapeHtml(product.title) + '">&times;</button>' +
          '</span>';
      }).join('');
    }
    if (skuLabel) skuLabel.hidden = selectedProducts.length !== 1;
    createCountLabel.textContent = selectedProducts.length > 1 ? ' (' + selectedProducts.length + ' products)' : '';
    if (selectedProducts.length && currentCreateStep === 0) clearError(createError);
  }

  function renderProductResults(products) {
    var selectedHandles = selectedProducts.map(function (product) { return product.handle; });
    latestSearchResults = products.filter(function (product) { return selectedHandles.indexOf(product.handle) === -1; });

    if (!latestSearchResults.length) {
      productResultsEl.innerHTML = '<p class="pmg__picker-empty">No matching products.</p>';
      productResultsEl.hidden = false;
      return;
    }

    productResultsEl.innerHTML = latestSearchResults.map(function (product, index) {
      var statusNote = product.status && product.status !== 'ACTIVE' ? ' &middot; ' + escapeHtml(product.status.toLowerCase()) : '';
      return '<button type="button" class="pmg__picker-result" data-pmg-pick-product="' + index + '">' +
        (product.image ? '<img src="' + escapeHtml(product.image) + '" alt="">' : '<span class="pmg__chip-noimg"></span>') +
        '<span>' + escapeHtml(product.title) + '<small>' + escapeHtml(product.handle) + statusNote + '</small></span>' +
        '</button>';
    }).join('');
    productResultsEl.hidden = false;
  }

  var searchDebounceTimer;
  function searchProducts(term) {
    api('/products?q=' + encodeURIComponent(term))
      .then(function (data) { renderProductResults(data.products || []); })
      .catch(function () { productResultsEl.hidden = true; });
  }

  productSearchInput.addEventListener('input', function () {
    clearTimeout(searchDebounceTimer);
    var term = productSearchInput.value;
    searchDebounceTimer = setTimeout(function () { searchProducts(term); }, 250);
  });

  productSearchInput.addEventListener('focus', function () {
    searchProducts(productSearchInput.value);
  });

  document.addEventListener('click', function (event) {
    if (event.target === productSearchInput || productResultsEl.contains(event.target)) return;
    productResultsEl.hidden = true;
  });

  productResultsEl.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pmg-pick-product]');
    if (!button) return;
    var product = latestSearchResults[Number(button.getAttribute('data-pmg-pick-product'))];
    if (product) {
      selectedProducts.push(product);
      renderSelectedProducts();
    }
    productSearchInput.value = '';
    productResultsEl.hidden = true;
  });

  selectedProductsEl.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pmg-remove-product]');
    if (!button) return;
    selectedProducts.splice(Number(button.getAttribute('data-pmg-remove-product')), 1);
    renderSelectedProducts();
  });

  // ---------------------------------------------------------------------
  // PDP promotion banner image upload
  // ---------------------------------------------------------------------

  function resetPdpImage() {
    pdpImageFileId = null;
    pdpImagePreview.hidden = true;
    pdpImagePreview.querySelector('img').src = '';
    pdpImageStatus.textContent = '';
    pdpImageInput.value = '';
  }

  function showPdpImagePreview(src, statusText) {
    var previewImg = pdpImagePreview.querySelector('img');
    previewImg.src = src;
    pdpImagePreview.hidden = false;
    pdpImageStatus.textContent = statusText || 'Image selected';
  }

  pdpImageInput.addEventListener('change', function () {
    var file = pdpImageInput.files && pdpImageInput.files[0];
    if (!file) return;

    pdpImageFileId = null;
    pdpImagePreview.hidden = true;
    pdpImageStatus.textContent = 'Uploading...';

    var formData = new FormData();
    formData.append('file', file);

    api('/uploads', { method: 'POST', body: formData })
      .then(function (data) {
        pdpImageFileId = data.id;
        if (data.previewUrl) {
          showPdpImagePreview(data.previewUrl, 'Uploaded');
        } else {
          showPdpImagePreview(URL.createObjectURL(file), 'Uploaded, processing on Shopify');
        }
        if (data.status && data.status !== 'READY') pdpImageStatus.textContent = 'Uploaded, processing on Shopify';
      })
      .catch(function (error) {
        pdpImageStatus.textContent = 'Upload failed: ' + error.message;
        pdpImageInput.value = '';
      });
  });

  pdpImageRemoveButton.addEventListener('click', resetPdpImage);

  // ---------------------------------------------------------------------
  // Auth + promotions CRUD
  // ---------------------------------------------------------------------

  loginForm.addEventListener('submit', function (event) {
    event.preventDefault();
    clearError(loginError);
    var formData = new FormData(loginForm);
    api('/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ passphrase: formData.get('passphrase') }),
    })
      .then(function () {
        loginForm.reset();
        showLoggedIn();
      })
      .catch(function (error) {
        showError(loginError, error.message);
      });
  });

  Array.prototype.forEach.call(viewButtons, function (button) {
    button.addEventListener('click', function () {
      var view = button.getAttribute('data-pmg-view-button');
      if (view === 'create') resetCreateForm();
      setAppView(view, view === 'promotions');
    });
  });

  Array.prototype.forEach.call(openCreateButtons, function (button) {
    button.addEventListener('click', function () {
      resetCreateForm();
      setAppView('create', false);
    });
  });

  if (prevStepButton) {
    prevStepButton.addEventListener('click', function () {
      setCreateStep(currentCreateStep - 1);
    });
  }

  if (nextStepButton) {
    nextStepButton.addEventListener('click', function () {
      if (validateCreateStep(currentCreateStep)) setCreateStep(currentCreateStep + 1);
    });
  }

  Array.prototype.forEach.call(stepIndicators, function (indicator) {
    indicator.addEventListener('click', function () {
      var requestedStep = Number(indicator.getAttribute('data-pmg-step-indicator'));
      if (requestedStep <= currentCreateStep) {
        setCreateStep(requestedStep);
        return;
      }
      for (var stepIndex = currentCreateStep; stepIndex < requestedStep; stepIndex += 1) {
        if (!validateCreateStep(stepIndex)) {
          setCreateStep(stepIndex);
          return;
        }
      }
      setCreateStep(requestedStep);
    });
  });

  refreshButton.addEventListener('click', loadPromotions);

  createForm.addEventListener('submit', function (event) {
    event.preventDefault();
    clearError(createError);

    if (currentCreateStep < createSteps.length - 1) {
      if (validateCreateStep(currentCreateStep)) setCreateStep(currentCreateStep + 1);
      return;
    }

    if (!validateCreateFlow()) return;

    var formData = new FormData(createForm);
    var baseBody = {};
    ['campaign', 'variant_sku', 'discount_percent', 'price', 'base_price', 'start_at', 'end_at', 'after_discount_percent', 'after_price', 'pdp_discount_code', 'pdp_link', 'pdp_bar_badge', 'pdp_bar_text', 'notes'].forEach(function (key) {
      var value = formData.get(key);
      if (value !== null && String(value).trim() !== '') baseBody[key] = value;
    });
    // datetime-local inputs have no timezone - treat them as the browser's
    // local time and convert to a real ISO instant before sending.
    ['start_at', 'end_at'].forEach(function (key) {
      if (baseBody[key]) {
        var asDate = new Date(baseBody[key]);
        if (!isNaN(asDate.getTime())) baseBody[key] = asDate.toISOString();
      }
    });
    // A variant SKU only makes sense when targeting exactly one product.
    if (selectedProducts.length > 1) delete baseBody.variant_sku;
    if (pdpImageFileId) baseBody.pdp_image = pdpImageFileId;

    createSubmitButton.disabled = true;

    if (editingPromotion) {
      if (selectedProducts.length !== 1) {
        createSubmitButton.disabled = false;
        showError(createError, 'Edit one promotion target at a time.');
        setCreateStep(0);
        return;
      }

      var updateBody = Object.assign({}, baseBody);
      if (selectedProducts[0].handle) {
        updateBody.product_handle = selectedProducts[0].handle;
      } else if (selectedProducts[0].variant_id) {
        updateBody.variant_id = selectedProducts[0].variant_id;
      }
      api('/promotions/' + encodeURIComponent(editingPromotion.id), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updateBody),
      })
        .then(function () {
          resetCreateForm();
          setAppView('promotions', false);
          loadPromotions();
        })
        .catch(function (error) {
          showError(createError, error.message);
        })
        .then(function () {
          createSubmitButton.disabled = false;
        });
      return;
    }

    var requests = selectedProducts.map(function (product) {
      var body = Object.assign({ product_handle: product.handle }, baseBody);
      return api('/promotions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
    });

    Promise.all(requests)
      .then(function () {
        createForm.reset();
        selectedProducts = [];
        renderSelectedProducts();
        resetPdpImage();
        setCreateStep(0);
        setAppView('promotions', false);
        loadPromotions();
      })
      .catch(function (error) {
        showError(createError, error.message + ' (some products in this batch may have already been created - check the list below.)');
      })
      .then(function () {
        createSubmitButton.disabled = false;
      });
  });

  function findPromotion(id) {
    return currentPromotions.filter(function (promotion) { return promotion.id === id; })[0] || null;
  }

  rowsBody.addEventListener('click', function (event) {
    var approveButton = event.target.closest('[data-pmg-approve]');
    var cancelButton = event.target.closest('[data-pmg-cancel]');
    var deleteButton = event.target.closest('[data-pmg-delete]');
    var editTarget = event.target.closest('[data-pmg-edit-promotion]');
    var approveId = approveButton && approveButton.getAttribute('data-pmg-approve');
    var cancelId = cancelButton && cancelButton.getAttribute('data-pmg-cancel');
    var deleteId = deleteButton && deleteButton.getAttribute('data-pmg-delete');

    if (approveId) {
      approveButton.disabled = true;
      api('/promotions/' + encodeURIComponent(approveId) + '/approve', { method: 'POST' })
        .then(loadPromotions)
        .catch(function (error) {
          window.alert('Could not approve: ' + error.message);
          approveButton.disabled = false;
        });
      return;
    }

    if (cancelId) {
      if (!window.confirm('Cancel this promotion? This cannot be undone.')) return;
      cancelButton.disabled = true;
      api('/promotions/' + encodeURIComponent(cancelId) + '/cancel', { method: 'POST' })
        .then(loadPromotions)
        .catch(function (error) {
          window.alert('Could not cancel: ' + error.message);
          cancelButton.disabled = false;
        });
      return;
    }

    if (deleteId) {
      if (!window.confirm('Delete this promotion permanently? This cannot be undone.')) return;
      deleteButton.disabled = true;
      api('/promotions/' + encodeURIComponent(deleteId) + '/delete', { method: 'POST' })
        .then(loadPromotions)
        .catch(function (error) {
          window.alert('Could not delete: ' + error.message);
          deleteButton.disabled = false;
        });
      return;
    }

    if (editTarget) {
      editPromotion(findPromotion(editTarget.getAttribute('data-pmg-edit-promotion')));
    }
  });

  rowsBody.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var editTarget = event.target.closest('tr[data-pmg-edit-promotion]');
    if (!editTarget) return;
    event.preventDefault();
    editPromotion(findPromotion(editTarget.getAttribute('data-pmg-edit-promotion')));
  });

  renderSelectedProducts();
  setCreateStep(0);
  setAppView('promotions', false);

  // On load, try the promotions list straight away - if the 12h session
  // cookie from a previous visit is still valid, this skips the login
  // screen; if not, the 401 falls through to showLoggedOut().
  api('/promotions')
    .then(function (data) {
      showLoggedIn(true);
      renderPromotions(data.promotions || []);
    })
    .catch(function () {
      showLoggedOut();
    });
})();
